<div class="p-6 w-full max-w-full">
  <h2 class="text-xl font-bold mb-4">Cambiar fecha límite</h2>

  <mat-form-field appearance="fill" class="w-full">
    <mat-label>Nueva fecha límite</mat-label>
    <input
      matInput
      [matDatepicker]="picker"
      [(ngModel)]="fechaSeleccionada"
      [min]="minDate"
      [matDatepickerFilter]="dateFilter"
      #fechaCtrl="ngModel"
      placeholder="Selecciona una fecha"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <div class="flex justify-end gap-2 mt-6">
    <button mat-stroked-button (click)="cerrar()">Cancelar</button>
    <button mat-flat-button color="primary" (click)="guardar()">
      Guardar
    </button>
  </div>
</div>
